<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="">
            <div>
              <AmountSelectorTorontoDinner />
            </div>
          </FormSection>
          <FormSection title="Reservations" v-if="form.amount">
            <div class="reserved__bstns">
              <div class="radio-part">
                <input
                  id="type_attending"
                  name="Attending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'yes'"
                  @click="setValue('custom.AttendInPerson', 'yes')"
                />
                <FormLabel for="type_attending"> YES, WILL ATTEND </FormLabel>
              </div>
              <div class="radio-part">
                <input
                  name="Attending"
                  id="type_noattending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'no'"
                  @click="setValue('custom.AttendInPerson', 'no')"
                />
                <FormLabel for="type_noattending"> NO, WILL NOT ATTEND </FormLabel>
              </div>
            </div>
            <ErrorLabel field="custom.AttendInPerson" />
            <div v-if="getValue('custom.AttendInPerson') == 'yes'">
              <br />
              <FormRow>
                <div style="width: 320px;margin:0 auto;">
                  <h2> How Many will attend? </h2>
                  <select style="margin: auto;" v-model="attending">
                    <option value="0">0</option>
                    <option v-for="index in Number(form.custom.ticketsQnt)" :key="index" :value="index">{{index}}</option>
                  </select>
                </div>
              </FormRow>
              <div v-if="attending">
                <h2>Attendee Names</h2>
                <FormRow v-for="index in attending" :key="index">
                  <div style="flex:1;margin-right: 10px">
                    <input 
                      type="text"
                      :value="names[index - 1] ? names[index - 1] : null"
                      @change="setName(index - 1, $event.target.value)"
                    >
                  </div>
                </FormRow>
              </div>              
            </div>  
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow>             
          </FormSection>
          <FormSection title="Contact Info">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <div class="payment-info">
              <div class="amex__notificion">We do not accept American Express (AMEX) cards at this time.</div>
              <FormRow inline>
                <FormCol field="card" :showLabel="false" />
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />
          <p class="note">
            <br />TAX RECEIPT ISSUED FOR THE MAXIMUM AMOUNT PERMITTED BY CRA.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent, watch, ref } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";
import AmountSelectorTorontoDinner from "./amount-selector-toronto-dinner.vue";

export default defineComponent({
  components: {
    AmountSelectorTorontoDinner,
  },
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, getValue, submit } = usePaymentForm();
    const attending = ref()
    const names = ref<string[]>([])

    setValue("country", "CA");
    setValue("currency", "CAD");

    function setName(index: any, value:String) {
      const nextValue: String = value
      names.value[index] = nextValue;
      setValue('custom.guests', names.value.toString());
    }

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      attending,
      setValue,
      getValue,
      setName,
      submit,
      names
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .form-container.ou-donation-form {
  position: relative;
}
.form-container.ou-donation-form {
  margin: 0px auto;
  padding: 10px;
  box-shadow: none;
  max-width: 750px;
}
::v-deep h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .note {
  font-style: italic;
  padding-top: 8px;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 50% !important;
  max-width: 50% !important;
  margin-bottom: 0px;
  border: 2px solid rgba(243, 235, 207, 1);
  padding: 3px;

  @media (min-width: 720px) {
    min-width: 25% !important;
    max-width: 25% !important;
  }
  input[type="radio"],
  input[type="checkbox"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;

  label {
    font-weight: 500;
    padding: 22px 0px;
    border: none;
    background: white !important;
    color: #131232 !important;
    display: flex !important;
    line-height: normal;
    margin-bottom: 0px;
    &:hover {
      background: radial-gradient(
        ellipse at center,
        rgba(249, 246, 233, 1) 0%,
        rgba(255, 255, 255, 1) 5%,
        rgba(241, 232, 199, 1) 100%
      ) !important;
    }
  }
  input[type="radio"]:checked + label,
  input[type="checkbox"]:checked + label {
    background: radial-gradient(
      ellipse at center,
      rgba(249, 246, 233, 1) 0%,
      rgba(255, 255, 255, 1) 5%,
      rgba(241, 232, 199, 1) 100%
    ) !important;
  }

  textarea {
    padding: 5px 10px;
    font-family: inherit;
  }
  ::v-deep .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 15px;
    font-style: italic;
    padding-top: 0;
  }
  .label-amount {
    background: none !important;
    display: inline-block !important;
    height: auto !important;
    max-width: 100%;
    text-align: center;
    color: rgba(175, 155, 83, 1);
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 7px;
    -o-border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-style: solid;
    border-width: 0px 0px 1px 0px;
  }
  #amount_other {
    max-width: 100%;
  }
  .amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
  }
  .amount_other__wrapper {
    margin-bottom: 18px;
  }
}

.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
::v-deep label {
  line-height: normal !important;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}

::v-deep .reserved__bstns {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .radio-part {
    min-width: 50% !important;
    max-width: 50% !important;
    border: 2px solid #f3ebcf;
    padding: 3px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;

    label {
      margin: 0px;
      padding: 13px;
      cursor: pointer;
      line-height: normal;
      width: 100%;
      text-align: center;
      /* font-weight: 600; */
      font-size: 17px;
      display: block;
      color: #131232;
      text-transform: capitalize;
      letter-spacing: 2px;
    }
    input[type="radio"],
  input[type="checkbox"] {
      height: 0;
      top: 20px;
      position: absolute;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }
    label:hover {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
    input[type="radio"]:checked + label,
    input[type="checkbox"]:checked + label {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
  }
}

::v-deep .payment-info {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}
::v-deep .payment {
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  border-bottom: 1px solid #efefef;
}
::v-deep label.control-label {
  flex: 1;
  max-width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  font-family: inherit;
  letter-spacing: 0px;
}

::v-deep h1 {
  padding-bottom: 0px;
  &:after {
    content: none;
    margin: 0px;
    padding: 0px;
  }
}

::v-deep .error-label {
  text-align: center;
}
.amex__notificion{
  font-style: italic;
    margin-bottom: 19px;
    font-size: 15px;
    margin-top: -7px;
}
</style>
